import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { openManageItemsInCollectionsDialogAction } from '../../../actions/spaces/Collections/ManageItemsInCollectionAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const OpenManageItemsInCollectionsDialogEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.AddToCollections,
  translateName: Messages.addToCollections,
  isVisible: (targetItems: IContentInfo[]) => {
    // TFS 1097690: should be false if user has no collections
    return FeatureFlags.collectionsEnabled && targetItems.length > 0 && !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (_availableActions: {}) => {
    return true;
  },
  createReduxAction: (targetItems: IContentInfo[]) => openManageItemsInCollectionsDialogAction(targetItems)
};
